/** biome-ignore-all lint/style/noMagicNumbers: TODO: migrate to react-query */
import i18n from 'i18next';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { getUserLocalStorage, setUserLocalStorage } from '@/modules/auth';
import { generateUUIDv4 } from '@/utils/number';

import { SEARCH_VIEW_TYPES, USER_PREFERENCES } from '../../contants/common';
import { convertThemeApiToLocal, getErrorMessageFromAPI } from '../../utilz';
import { setLDClaimViewTypeInitial } from '../Claims/LossAndDamage/LossAndDamageClaimsActions';
import { LossAndDamageClaimsTypes } from '../Claims/LossAndDamage/LossAndDamageClaimsTypes';
import { setOCClaimViewTypeInitial } from '../Claims/OverCharge/OverChargeActions';
import { OverChargeClaimsTypes } from '../Claims/OverCharge/OverChargeTypes';
import { setAppLoader } from '../common/CommonActions';
import { setSearchViewTypeTypeInitial, setShipmentProductViewTypeInitial } from '../shipment/ShipmentActions';
import ShipmentTypes from '../shipment/ShipmentTypes';
import {
  approveRejectShipmentInFail,
  approveRejectShipmentInSuccess,
  changeCompanyInFail,
  changeCompanyInSuccess,
  getUserMenuInError,
  getUserMenuInSuccess,
  getUserMenuItemsInError,
  getUserMenuItemsInSuccess,
  getUserPreferenceInError,
  getUserPreferenceInSuccess,
  getUserProfileInError,
  getUserProfileInSuccess,
  setLoginSuccess,
} from './AuthActions';
import {
  approveRejectShipmentEffects,
  getUserMenuEffect,
  getUserMenuItemsEffect,
  getUserPreferenceEffect,
  getUserProfileEffect,
  updateUserPreferenceEffect,
} from './AuthEffects';
import AuthTypes from './AuthTypes';

function* getUserMenu() {
  try {
    const { data } = yield call(getUserMenuEffect);
    yield put(getUserMenuInSuccess({ data }));
  } catch (e) {
    yield put(getUserMenuInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getUserMenuItems({ payload }) {
  try {
    const { data } = yield call(getUserMenuItemsEffect, payload.NavigationID);
    yield put(getUserMenuItemsInSuccess({ data }));
  } catch (e) {
    yield put(getUserMenuItemsInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getUserProfile() {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getUserProfileEffect);
    yield put(getUserProfileInSuccess({ data }));
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(getUserProfileInError({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

function* getUserPreference({ payload }) {
  try {
    const { data } = yield call(getUserPreferenceEffect, payload);
    yield put(getUserPreferenceInSuccess({ data: convertThemeApiToLocal(data) }));
    yield put(
      setSearchViewTypeTypeInitial(
        data[USER_PREFERENCES.SHIPMENT_VIEW_TYPE] ? data[USER_PREFERENCES.SHIPMENT_VIEW_TYPE] : SEARCH_VIEW_TYPES.CARD,
      ),
    );
    yield put(
      setShipmentProductViewTypeInitial(
        data[USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]
          ? data[USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]
          : SEARCH_VIEW_TYPES.CARD,
      ),
    );
    yield put(
      setOCClaimViewTypeInitial(
        data[USER_PREFERENCES.OC_CLAIM_VIEW_TYPE] ? data[USER_PREFERENCES.OC_CLAIM_VIEW_TYPE] : SEARCH_VIEW_TYPES.CARD,
      ),
    );
    yield put(
      setLDClaimViewTypeInitial(
        data[USER_PREFERENCES.LD_CLAIM_VIEW_TYPE] ? data[USER_PREFERENCES.LD_CLAIM_VIEW_TYPE] : SEARCH_VIEW_TYPES.CARD,
      ),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.notification.userPreferenceFailed'));
    yield put(
      getUserPreferenceInError({
        message: errorMessage,
      }),
    );
  }
}
function* changeCompanyAction({ payload }) {
  const userData = yield select((state) => state.auth.user.data);
  try {
    const { userInfo } = getUserLocalStorage();
    const data = {
      ...userInfo,
      selectedCompany: payload.CompanyID,
      userGuid: generateUUIDv4(),
    };

    yield call(setUserLocalStorage, data);
    yield put(setLoginSuccess({ data: { ...userData, selectedCompany: payload.CompanyID } }));
    yield put(changeCompanyInSuccess({ CompanyID: payload.CompanyID }));
  } catch (e) {
    yield put(changeCompanyInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* approveRejectShipment({ payload }) {
  try {
    const { data } = yield call(approveRejectShipmentEffects, payload);
    yield put(approveRejectShipmentInSuccess({ message: data }));
  } catch (e) {
    yield put(
      approveRejectShipmentInFail({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.notification.shipmentStatusFailed')),
      }),
    );
  }
}

function* updateShipmentGridViewType({ payload }) {
  yield delay(5000);
  const userPreference = yield select((state) => state.auth.getUserPreference.data);
  try {
    const payloadData = {
      ...userPreference,
      [USER_PREFERENCES.SHIPMENT_VIEW_TYPE]: payload,
    };
    yield call(updateUserPreferenceEffect, payloadData);
  } catch (e) {
    console.log(e);
  }
}

function* updateShipmentProductGridViewType({ payload }) {
  yield delay(5000);
  const userPreference = yield select((state) => state.auth.getUserPreference.data);
  try {
    const payloadData = {
      ...userPreference,
      [USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]: payload,
    };
    yield call(updateUserPreferenceEffect, payloadData);
  } catch (e) {
    console.log(e);
  }
}

function* updateLDClaimGridViewType({ payload }) {
  const userPreference = yield select((state) => state.auth.getUserPreference.data);
  try {
    yield delay(5000);
    const payloadData = {
      ...userPreference,
      [USER_PREFERENCES.LD_CLAIM_VIEW_TYPE]: payload,
    };
    yield call(updateUserPreferenceEffect, payloadData);
  } catch (e) {
    console.log(e);
  }
}

function* updateOCClaimGridViewType({ payload }) {
  const userPreference = yield select((state) => state.auth.getUserPreference.data);
  try {
    yield delay(5000);
    const payloadData = {
      ...userPreference,
      [USER_PREFERENCES.OC_CLAIM_VIEW_TYPE]: payload,
    };
    yield call(updateUserPreferenceEffect, payloadData);
  } catch (e) {
    console.log(e);
  }
}

export default function* authSaga() {
  yield takeLatest(AuthTypes.GET_USER_MENU_PROGRESS, getUserMenu);
  yield takeLatest(AuthTypes.GET_USER_MENU_ITEMS_PROGRESS, getUserMenuItems);
  yield takeLatest(AuthTypes.GET_USER_PROFILE_PROGRESS, getUserProfile);
  yield takeLatest(AuthTypes.GET_USER_PREFERENCE_PROGRESS, getUserPreference);
  yield takeLatest(AuthTypes.CHANGE_COMPANY_IN_PROGRESS, changeCompanyAction);
  yield takeLatest(AuthTypes.APPROVE_REJECT_SHIPMENT_IN_PROGRESS, approveRejectShipment);
  yield takeLatest(ShipmentTypes.SET_SHIPMENT_SEARCH_VIEW_TYPE, updateShipmentGridViewType);
  yield takeLatest(LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE, updateLDClaimGridViewType);
  yield takeLatest(ShipmentTypes.SET_SHIPMENT_PRODUCT_VIEW_TYPE, updateShipmentProductGridViewType);
  yield takeLatest(OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE, updateOCClaimGridViewType);
}
